import {NgModule, Injectable} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {RouterModule, Routes, CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';

import { MatSidenavModule } from '@angular/material';
import { FileDataService } from './commons/file-data.service';
import { AppBaseComponent, HomeComponent } from './app.component';
import { Vasat } from 'vasat';
import { StreamDataService } from './commons/stream-data.service';
import { KeyboardService } from './commons/keyboard.service';
import { TreeNodeBuilder } from './commons/files/tree-events';

@Injectable()
export class LoginNeeded implements CanActivate {
  constructor(protected V: Vasat, protected r: Router) {}
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.V.localSession()) return true
    else {
      this.r.navigate(['/auth'], {queryParams: {prevpage: state.url, msg: 'Login Timed out'}})
      return false
    }
  }
}

const Routes: Routes = [
  { path: ':team', component:AppBaseComponent,
    children:[
      { path: '', component:HomeComponent },
      { path: 'project', loadChildren: () => import( './project/index').then(m => m.ProjectMapModule) },
      { path: 'files', loadChildren: () => import( './files/index').then(m => m.FileModule) }
    ]
  }
];

@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    MatSidenavModule,
    RouterModule.forChild(Routes)
  ],
  declarations:[
    AppBaseComponent,HomeComponent
  ],
  providers:[
    LoginNeeded, KeyboardService, TreeNodeBuilder
  ],
  entryComponents: []

})

export class Ver2Module {


}


